import { ReactNode, ReactElement, useState } from 'react';
import styles from './ui-pressable-area.module.scss';

export type UIPressableAreaVariant = 'default' | 'primary' | 'danger';

export type UIPressableAreaProps = {
    children: (props: { hover: boolean }) => ReactNode;
    variant?: UIPressableAreaVariant;
    disabled?: boolean;
    onClick?: () => void;
    padding?: number;
    horizontalPadding?: number;
    verticalPadding?: number;
    width?: number;
    height?: number;
    border?: boolean;
    type?: 'button' | 'reset' | 'submit';
};
export const UIPressableArea: React.FC<UIPressableAreaProps> = (props) => {
    const { disabled = false, onClick, type } = props;

    const [hover, setHover] = useState(false);

    const handleMouseEnter = () => setHover(true);
    const handleMouseLeave = () => setHover(false);

    return (
        <button
            className={styles.button}
            disabled={disabled}
            onClick={onClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            type={type}
        >
            <UIPressableAreaButtonLess {...props}>
                {props.children({ hover })}
            </UIPressableAreaButtonLess>
        </button>
    );
};

export type UIPressableAreaButtonLessProps = {
    children?: ReactNode;
    variant?: UIPressableAreaVariant;
    disabled?: boolean;
    onClick?: () => void;
    padding?: number;
    horizontalPadding?: number;
    verticalPadding?: number;
    width?: number;
    height?: number;
    border?: boolean;
};

export function UIPressableAreaButtonLess(
    props: UIPressableAreaButtonLessProps
): ReactElement {
    const {
        children,
        variant = 'default',
        padding,
        horizontalPadding = padding,
        verticalPadding = padding,
        width,
        height,
        border = true
    } = props;

    const contentClasses = [
        styles.content,
        styles[variant],
        border ? styles.border : styles.noBorder
    ];

    return (
        <div
            className={contentClasses.join(' ')}
            style={{
                paddingLeft: horizontalPadding,
                paddingRight: horizontalPadding,
                paddingTop: verticalPadding,
                paddingBottom: verticalPadding,
                width,
                height
            }}
        >
            {children}
        </div>
    );
}
